import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';


const ReviewSlider = () => {

    const reviews = [
        {
            id: 1,
            name: "Mansi Shah",
            review: "Outstanding experience with Virya Wildlife Tours",
            description: "We took 1 Buffer zone safari and 2 Core zone safaris. We ended up finding 3 tigers - Yuvraj, Bijli and Rudra...",
            rating: 5
        },
        {
            id: 2,
            name: "Nikhil S",
            review: "Tadoba Andhari Tiger Reserve Safari",
            description: "Entire Tadoba booking was managed by Virya Wildlife Tours. Paras, Viral and team had made fantastic arrangements! throughout the trip we were on auto pilot and didnt have to worry for anything.. everything was simply awesome, hotel, food, Safari experience! Would highly recommend to book through them!",
            rating: 5
        },
        {
            id: 3,
            name: "Jessica Ved",
            review: "Excellent!!!",
            description: "Everything was very well organised by Paras Savla. This was our first safari trip but it was amazingEverything was very well organised by paras Savla. He is a very good host. Our whole trip went on very smoothly. This was our first safari trip but it was just amazing. The hotel paras had put up us in was very good and the food was very good too.",
            rating: 5
        },
        {
            id: 4,
            name: "Mansi Shah",
            review: "Outstanding experience with Virya Wildlife Tours",
            description: "We took 1 Buffer zone safari and 2 Core zone safaris. We ended up finding 3 tigers - Yuvraj, Bijli and Rudra...",
            rating: 5
        },
        {
            id: 5,
            name: "Nikhil S",
            review: "Tadoba Andhari Tiger Reserve Safari",
            description: "Entire Tadoba booking was managed by Virya Wildlife Tours. Paras, Viral and team had made fantastic arrangements! throughout the trip we were on auto pilot and didnt have to worry for anything.. everything was simply awesome, hotel, food, Safari experience! Would highly recommend to book through them!",
            rating: 5
        },
        {
            id: 6,
            name: "Jessica Ved",
            review: "Excellent!!!",
            description: "Everything was very well organised by Paras Savla. This was our first safari trip but it was amazingEverything was very well organised by paras Savla. He is a very good host. Our whole trip went on very smoothly. This was our first safari trip but it was just amazing. The hotel paras had put up us in was very good and the food was very good too.",
            rating: 5
        }
    ];

    return (
        <section className='my-5 ReviewsSection'>
            <div className='row mx-0 text-center Travelsectiontop'>
                <h5>Customers Reviews</h5>
                <h4>See What Our Clients Say About Us</h4>
            </div>
            <div className="row mt-5 justify-content-center">
                <div className="col-lg-12 col-md-12">
                    <div className='customerReview m-0'>
                        <Swiper
                            freeMode={true}
                            autoplay={true}
                            breakpoints={{
                                1200: { slidesPerView: 3.5, spaceBetween: 30 },
                                1024: { slidesPerView: 2.5, spaceBetween: 30 },
                                768: { slidesPerView: 2, spaceBetween: 20 },
                                400: { slidesPerView: 1, spaceBetween: 10 },
                            }}
                            modules={[Autoplay, Navigation, FreeMode]}
                            className="mySwiper"
                        >
                            {reviews.map((review) => (
                                <SwiperSlide key={review.id}>
                                    <div className='reviewbox'>
                                        <div className="topReviewbox">
                                            <h4>{review.name}</h4>
                                            <p className='starReview'>{'⭐'.repeat(review.rating)}</p>
                                        </div>
                                        <div className="bottomReviewbox">
                                            <p className='namereview'>{review.review}</p>
                                            <p>{review.description}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReviewSlider;
